import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid'
import CtaBtn from '../UIElements/CtaBtn';
import * as amplitude from '@amplitude/analytics-browser';

const CountryPromptBanner = React.forwardRef(({closeBanner, country}, ref) => {

  const [ deviceId, setDeviceId] = React.useState(null);
  const [ sessionId, setSessionId] = React.useState(null);

  React.useEffect(() => {
    const getDeviceId = amplitude.getDeviceId();
    const getSessionId = amplitude.getSessionId();
    setDeviceId(getDeviceId);
    setSessionId(getSessionId);
  }, []);

  const countryCode = {
    US: 'com',
    DE: 'de',
  };

  const countryName = {
    US: 'the USA',
    DE: 'Germany',
  };

  const handleUpdateIDs = () => {
    const getDeviceId = amplitude.getDeviceId();
    const getSessionId = amplitude.getSessionId();
    setDeviceId(getDeviceId);
    setSessionId(getSessionId);
  }

  return (
    <div className="relative isolate flex items-center gap-x-6 overflow-hidden bg-gray-50 px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
      <div
        aria-hidden="true"
        className="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-577/310 w-[36.0625rem] bg-linear-to-r from-[#E16F32] to-[#205E92] opacity-30"
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
          }}
          className="aspect-577/310 w-[36.0625rem] bg-linear-to-r from-[#E16F32] to-[#205E92] opacity-30"
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <p className="text-sm/6 text-gray-900">
          <strong className="font-semibold">Acccessing from {countryName[country]}?</strong>
          <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
            <circle r={1} cx={1} cy={1} />
          </svg>
          Did you know we have a dedicated team of consultants in {countryName[country]}?
        </p>
        <CtaBtn
          href={`https://www.theinformationlab.${countryCode[country]}?utm_source=til_uk&utm_medium=website&utm_campaign=country_prompt&ampDeviceId=${deviceId}&ampSessionId=${sessionId}`}
          colour={'orange'}
          size={'small'}
          secondary={false}
          label={<>Visit The Information Lab {country} <span aria-hidden="true" className='ml-2'>&rarr;</span></>}
          onHover={handleUpdateIDs}
          newTab={true}
        />
      </div>
      <div className="flex flex-1 justify-end">
        <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px] rounded-full hover:bg-global-500/15 cursor-pointer"
          onClick={() => closeBanner()}>
          <span className="sr-only">Dismiss</span>
          <XMarkIcon aria-hidden="true" className="size-5 text-gray-900" />
        </button>
      </div>
    </div>
  )
});

export default CountryPromptBanner;
